import React, { useContext, Component } from 'react'
import { themeContext } from 'global/context/sub-contexts/themeContext'

///
/// NOTE: this has largely been deprecated. Please use step3.
///

// redesigned new steps
import CompleteStep from 'steps/complete/CompleteStep'
import FilteringStep from 'steps/filtering/FilteringStep'
import ListicleStep from 'steps/listicle/NewListicleStep'
import ReviewStep from 'steps/review/ReviewStep'
import TextTriviaStep from 'steps/text-trivia/NewTextTriviaStep'
//import VideoStep from "steps/video/VideoStep"
import LocatorStep from 'steps/locator/LocatorStep'
import PinterestStep from 'steps/pinterest/PinterestStep'
import ArticleStep from 'steps/article/ArticleStep'

import ReferralStep from 'steps/referral/ReferralStep'
import PuzzleStep from 'steps/puzzle/PuzzleStep'

import LockedStep from 'steps/LockedStep'
import BreakHTMLFooter from './BreakHTMLFooter'

/*
    for now: wrapping our functional step component with a React.Component that gives
    us better control over re-rendering.there
*/

class Step extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.isLocked !== this.props.isLocked) {
      return true
    }

    if (nextProps.stepId !== this.props.stepId) {
      return true
    }

    if (nextProps.breakId !== this.props.breakId) {
      return true
    }

    // steps use isComplete prop to determine how to render their next arrow.
    // we'd like to migrate away from this. In the meantime, this allows us to control behavior as-needed
    if (nextProps.isComplete !== this.props.isComplete) {
      let needsRerenderForIsComplete = true

      if (['PERSONALITY_QUIZ'].indexOf(this.props.step.type) >= 0) {
        needsRerenderForIsComplete = false
      }

      return needsRerenderForIsComplete
    }

    if (nextProps.scrollComplete !== this.props.scrollComplete) {
      return true
    }

    return false
  }

  render() {
    return (
      <div className="inner-step-wrapper">
        <InnerStep
          brk={this.props.brk}
          step={this.props.step}
          breakId={this.props.breakId || this.props.brk.id}
          stepId={this.props.stepId}
          isLocked={this.props.isLocked}
          isStarted={this.props.isStarted}
          isComplete={this.props.isComplete}
          isEditorial={this.props.isEditorial}
          onGoToNext={this.props.onGoToNext}
          onStepStart={this.props.onStepStart}
          onStepComplete={this.props.onStepComplete}
          unlockNextStep={this.props.unlockNextStep}
          onStepSkip={this.props.onStepSkip}
          isEmbed={this.props.isEmbed}
          terms={this.props.brk.customAbbreviatedTerms}
          relatedBreaks={this.props.relatedBreaks}
          scrollComplete={this.props.scrollComplete}
          onAuthRequired={this.props.onAuthRequired}
          onUnhandledError={this.props.onUnhandledError}
          handleAwardPoints={this.props.handleAwardPoints}
        />
      </div>
    )
  }
}

const InnerStep = ({
  brk,
  step,
  breakId,
  stepId,
  isLocked,
  isComplete,
  onStepSkip,
  backLinkHandler,
  useNewStepType,
  onGoToNext,
  onStepStart,
  onStepComplete,
  unlockNextStep,
  isEmbed,
  isEditorial,
  terms,
  relatedBreaks,
  scrollComplete,
  onAuthRequired,
  onUnhandledError,
  handleAwardPoints,
}) => {
  const BreakFooter = () => <BreakHTMLFooter content={brk.footerHtml} />
  let colors = useContext(themeContext)
  if (colors) {
    if (step && step.mission) {
      colors.styles.mission = true
      colors.styles._mission = {
        missionColor1: step.missionColor1,
        missionColor2: step.missionColor2,
        missionColor3: step.missionColor3,
        missionColor4: step.missionColor4,
        missionColor5: step.missionColor5,
        missionColor6: step.missionColor6,
        missionColor7: step.missionColor7,
        missionColor8: step.missionColor8,
        replayColor: step.replayColor,
        pointsTextColor: step.pointsTextColor,
        stepShareBarColor: step.stepShareBarColor,
        questionNavColor: step.questionNavColor,
        questionNavTextColor: step.questionNavTextColor,
        questionNavCorrectColor: step.questionNavCorrectColor,
        questionNavIncorrectColor: step.questionNavIncorrectColor,
        termsColor: step.termsColor,
        landingPageHeadlineColor: step.landingPageHeadlineColor,
        mobileLandingPageHeadlineColor: step.mobileLandingPageHeadlineColor,
        landingPageIntroColor: step.landingPageIntroColor,
        mobileLandingPageIntroColor: step.mobileLandingPageIntroColor,
        websiteCopyColor: step.websiteCopyColor,
        mobileWebsiteCopyColor: step.mobileWebsiteCopyColor,
        backgroundColor: step.backgroundColor,
        useNavAndFooterColor: false,
        navAndFooterBackgroundColor: step.navAndFooterBackgroundColor,
        navAndFooterFontColor: step.navAndFooterFontColor,
        navAndFooterImageColor: step.navAndFooterImageColor,
      }
    } else {
      colors.styles.mission = true
      colors.styles._mission = {
        navAndFooterBackgroundColor: '#704ea2',
        navAndFooterFontColor: '#fff',
        navAndFooterImageColor: step.navAndFooterImageColor,
      }
    }
  }

  const getStepByType = (
    step,
    breakId,
    isComplete,
    onGoToNext,
    onStepStart,
    onStepComplete,
    unlockNextStep,
    onStepSkip,
    isEditorial,
    brk,
    terms,
    relatedBreaks,
    isStarted,
    onAuthRequired,
    onUnhandledError,
  ) => {
    let stepProps = {
      step: step,
      breakId: breakId,
      onGoToNext: onGoToNext,
      onStepStart: onStepStart,
      onStepComplete: onStepComplete,
      unlockNextStep: unlockNextStep,
      isComplete: isComplete,
      onStepSkip: onStepSkip,
      brk: brk,
      isEmbed: isEmbed,
      isEditorial: isEditorial,
      relatedBreaks: relatedBreaks,
      scrollComplete: scrollComplete,
      onAuthRequired: onAuthRequired,
      onUnhandledError: onUnhandledError,
      handleAwardPoints: handleAwardPoints,
      terms: terms,
      isStarted: isStarted,
      HtmlFooter: BreakFooter,
    }

    if (step.type === 'COMPLETE') {
      return <CompleteStep {...stepProps} />
    } else if (step.type === 'FILTERING') {
      return <FilteringStep {...stepProps} />
    } else if (step.type === 'LISTICLE') {
      return <ListicleStep {...stepProps} />
    } else if (step.type === 'REVIEW') {
      return <ReviewStep {...stepProps} />
    } else if (step.type === 'TEXT_TRIVIA') {
      return <TextTriviaStep {...stepProps} />
    } else if (step.type === 'STORE_FINDER') {
      return <LocatorStep {...stepProps} />
    } else if (step.type === 'ARTICLE') {
      return <ArticleStep {...stepProps} />
    } else if (step.type === 'PUZZLE') {
      return <PuzzleStep {...stepProps} />
    } else if (step.type === 'REFERRAL') {
      return <ReferralStep {...stepProps} />
    } else if (step.type === 'PINTEREST') {
      return <PinterestStep {...stepProps} />
    } else {
      return <></>
    }
  }

  return (
    <>
      {isLocked && (
        <section className="sponsored-flow-panel">
          {/* TODO - there's probably a better way to do this bgimage thing */}
          <LockedStep
            backgroundImageId={
              step.startBackgroundImageId ||
              (step.backgroundImage && step.backgroundImage.id)
            }
            backgroundColor={step.startBackgroundColor}
            HtmlFooter={BreakFooter}
          />
        </section>
      )}
      {!isLocked &&
        step &&
        getStepByType(
          step,
          breakId,
          isComplete,
          onGoToNext,
          onStepStart,
          onStepComplete,
          unlockNextStep,
          onStepSkip,
          isEditorial,
          brk,
          terms,
          relatedBreaks,
          scrollComplete,
          onAuthRequired,
          onUnhandledError,
          handleAwardPoints,
        )}
    </>
  )
}

export default Step
